

























































import { Component, Watch } from 'vue-property-decorator';
import { Action, namespace, State } from 'vuex-class';
import { ToastProgrammatic as Toast } from 'buefy';
import { mixins } from 'vue-class-component';
import EnablerList from './EnablerList.vue';
import BasePaginatorHoc from '../../../components/base/BasePaginatorHoc.vue';
import {
  CreateGripEnablerBase,
  CreateGripEnablerPayload,
  GetEnablersPayload,
  GripEnabler,
  GripEnablerDTO,
  UpdateGripEnablerBase,
  UpdateGripEnablerPayload,
} from '../../../store/types/grip.types';
import EnablerModal from './EnablerModal.vue';
import {
  ApiState,
  Pagination,
  PaginatorDto,
} from '../../../store/types/general.types';
import { Debounce } from '../../../jbi-shared/util/debounce.vue-decorator';
import BaseLoading from '../../../components/base/BaseLoading.vue';
import {
  isDifferentDeep,
  isTruthy,
} from '../../../jbi-shared/util/watcher.vue-decorator';
import { showUnsavedChangesDialog } from '@/utils/dialog.util';
import DeleteModalBox from '@/components/DeleteModalBox.vue';
import GripSettingsModalManagerMixin from '@/views/Grip/components/grip-settings-modal-manager.mixin';

@Component({
  components: { BaseLoading, BasePaginatorHoc, EnablerList, EnablerModal },
})
export default class EnablerSettings extends mixins(
  GripSettingsModalManagerMixin,
) {
  public entityName: string = 'Enabler';
  public entityIdKey: string = 'enablerId';

  @Action('projects/getGripEnablers')
  public getGripEnablers!: (payload: {
    projectId: number;
    params: GetEnablersPayload;
  }) => void;

  @State((state) => state.projects.gripEnablers)
  public gripEnablers!: Pagination<GripEnabler>;

  @State((state) => state.projects.apiState.getGripEnablers)
  public getGripEnablersApiState!: ApiState;

  @Action('projects/createGripEnabler')
  public createGripEnabler!: (payload: CreateGripEnablerPayload) => void;

  @State((state) => state.projects.apiState.createGripEnabler)
  public createGripEnablerApiState!: ApiState;

  // Added action for updating enabler
  @Action('projects/updateGripEnabler')
  public updateGripEnabler!: (payload: UpdateGripEnablerPayload) => void;

  // Added state for updateGripEnabler API
  @State((state) => state.projects.apiState.updateGripEnabler)
  public updateGripEnablerApiState!: ApiState;

  @Action('projects/deleteGripEnabler')
  public deleteGripEnabler!: (payload: {
    projectId: number;
    enablerId: number;
  }) => void;

  @State((state) => state.projects.apiState.deleteGripEnabler)
  public deleteGripEnablerApiState!: ApiState;

  public getAction = this.getGripEnablers;
  public deleteAction = this.deleteGripEnabler;

  get getApiState(): ApiState {
    return this.getGripEnablersApiState;
  }
  get createApiState(): ApiState {
    return this.createGripEnablerApiState;
  }
  get updateApiState(): ApiState {
    return this.updateGripEnablerApiState;
  }
  get deleteApiState(): ApiState {
    return this.deleteGripEnablerApiState;
  }

  get EnablerList() {
    return EnablerList;
  }

  get getGripEnablerList(): GripEnabler[] {
    return this.gripEnablers.items || [];
  }

  get totalCount(): number {
    return this.gripEnablers.totalItems || 0;
  }

  /**
   * Handles the creation of a new enabler.
   * @param {CreateGripEnablerBase} gripEnabler - Data from the modal form.
   */
  public handleEnablerCreate(gripEnabler: CreateGripEnablerBase): void {
    this.createGripEnabler({ ...gripEnabler, projectId: this.projectId });
  }

  /**
   * Handles the update of an existing enabler.
   * @param {UpdateGripEnablerBase} gripEnablerUpdateData - Data from the modal form.
   */
  public handleEnablerUpdate(
    gripEnablerUpdateData: UpdateGripEnablerBase & { id: number },
  ): void {
    if (
      this.editingEntityId !== null &&
      this.editingEntityId === gripEnablerUpdateData.id
    ) {
      const { id, ...changesToApply } = gripEnablerUpdateData;

      if (Object.keys(changesToApply).length > 0) {
        const payload: UpdateGripEnablerPayload = {
          ...gripEnablerUpdateData,
          id: this.editingEntityId,
          projectId: this.projectId,
        };
        this.updateGripEnabler(payload);
      } else {
        this.closeModal();
      }
    } else {
      this.closeModal();
    }
  }
}
